module.exports = __webpack_public_path__ + "img/edge-250.b0d61ceb.png";